import { usePerformanceAudienceFormatters } from '../../hooks/usePerformanceAudienceFormatters';
import { PerformanceAudienceSummary } from '@/services/endpoints/performanceAudience';
import { FC } from 'react';
import { Trans } from 'react-i18next';

type FilterSummaryLineProps = {
  summary: PerformanceAudienceSummary;
};

export const FilterSummaryLine: FC<FilterSummaryLineProps> = ({ summary }) => {
  const { formatNumber } = usePerformanceAudienceFormatters();

  return (
    <div className='flex flex-wrap items-center gap-2 px-0.5 text-[12.5px] text-ink-600'>
      <span className='inline-block size-[7px] shrink-0 rounded-full bg-success-600 shadow-[0_0_0_3px_var(--success-100)]' aria-hidden />
      <Trans
        i18nKey='performanceAudience:filters.summaryRich'
        values={{
          googleCount: summary.googleAccountCount,
          metaCount: summary.metaAdAccountCount,
          audienceName: summary.audienceName,
          userCount: formatNumber(summary.audienceUserCount),
        }}
        components={{
          bold: <b className='font-semibold text-ink-900' />,
        }}
      />
    </div>
  );
};
